var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4394 4.23038C26.1448 3.20889 28.7912 5.85518 27.7696 8.56064L21.4046 25.4186C20.047 29.014 14.8942 28.8127 13.8214 25.1222L12.4621 20.4461C12.3347 20.0079 11.9921 19.6653 11.5539 19.538L6.87773 18.1786C3.1873 17.1058 2.98595 11.953 6.58139 10.5955L23.4394 4.23038ZM25.2749 7.61869C25.4857 7.06042 24.9396 6.51436 24.3813 6.72514L7.52334 13.0902C6.32484 13.5427 6.39198 15.2603 7.62211 15.6179L12.2983 16.9773C13.6128 17.3594 14.6406 18.3872 15.0227 19.7017L16.3821 24.3779C16.7397 25.608 18.4573 25.6751 18.9098 24.4767L25.2749 7.61869Z",
    fill: "#202020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationArrow);
export default __webpack_public_path__ + "static/media/location-arrow.94b6b98da066d7a7bf2ef3db359f7b1b.svg";
export { ForwardRef as ReactComponent };